<div class="slideshow-container" [class.is-dragging]="isDragging">
  <iframe
    [src]="currentIframeUrl"
    [class.active]="activeIframe === EIframeState.current"
    class="slideshow-iframe"
    frameborder="0"
    width="100%"
  ></iframe>
  <iframe
    [src]="nextIframeUrl"
    [class.active]="activeIframe === EIframeState.next"
    class="slideshow-iframe"
    frameborder="0"
    width="100%"
  ></iframe>

  @if (dashboardUrls.length > 1) {
    <app-slideshow-controller
      [totalSeconds]="slideshow().slideDurationSeconds"
      [countdownManager]="countdownManager"
      (manualChange)="onManualChange($event)"
      (dragStarted)="onDragStarted()"
      (dragEnded)="onDragEnded()"
    >
    </app-slideshow-controller>
  }
</div>
